import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const COOKIE_CONSENT_KEY = "cayus-cookie-consent";

const translations = {
  en: {
    text: "We use cookies to analyze our traffic.",
    accept: "Accept",
    decline: "Decline",
  },
  fr: {
    text: "Nous utilisons des cookies pour analyser notre trafic.",
    accept: "Accepter",
    decline: "Refuser",
  },
  es: {
    text: "Utilizamos cookies para analizar nuestro tráfico.",
    accept: "Aceptar",
    decline: "Rechazar",
  },
};

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();
  const t = translations[language] || translations.en;

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent === null) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
    window.dispatchEvent(new Event("cayus-cookie-consent"));
    if (window.gtag) {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
    window.dispatchEvent(new Event("cayus-cookie-consent"));
    if (window.gtag) {
      window.gtag("consent", "update", { analytics_storage: "denied" });
    }
    window["ga-disable-G-80ZZBNZGLC"] = true;
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-50 animate-in slide-in-from-bottom duration-300"
      data-testid="cookie-banner"
    >
      <div className="bg-slate-900 text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3">
        <p className="text-sm text-[#E4EEFC] flex-1">{t.text}</p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="text-xs text-[#9098A3] hover:text-white transition-colors px-2 py-1"
            data-testid="cookie-decline"
          >
            {t.decline}
          </button>
          <button
            onClick={handleAccept}
            className="text-xs font-medium bg-[#0047AB] hover:bg-[#0047AB] text-white px-3 py-1.5 rounded-lg transition-colors"
            data-testid="cookie-accept"
          >
            {t.accept}
          </button>
        </div>
        <button
          onClick={handleDecline}
          className="p-1 hover:bg-white/10 rounded transition-colors"
          aria-label="Close"
        >
          <X className="w-3.5 h-3.5 text-[#9098A3]" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
